import { render, staticRenderFns } from "./main.html?vue&type=template&id=8159753a&"
import script from "./main.js?vue&type=script&lang=js&"
export * from "./main.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports